// Thin wrapper around POST /api/admin/seed-demo and the public
// POST /api/admin/bootstrap-demo helper used by the Login.js demo button
// to self-heal a stale `admin@etqan.demo` account.
//
// seedDemoData() returns the full SeedResult shape:
//   { ok, tenantId, counts, credentials }
// bootstrapDemoAdmin() returns:
//   { ok, email, password, tenantId, displayName }

import { apiFetch } from './_apiClient';

export const adminSeedService = {
  async seedDemoData() {
    return apiFetch('/api/admin/seed-demo', { method: 'POST', timeoutMs: 180000 });
  },
  // Append-only seed: generates wirds + attendance + sessions for dates
  // strictly after each student's last existing wird date. Does NOT wipe.
  async seedIncrementalData() {
    return apiFetch('/api/admin/seed-incremental', { method: 'POST', timeoutMs: 180000 });
  },
  async bootstrapDemoAdmin() {
    return apiFetch('/api/admin/bootstrap-demo', { method: 'POST' });
  },
};
